// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"050dcd05","119":"55172444","186":"674f27c8","201":"c2ad0d1c","344":"99ddf5e7","372":"b5aeeb57","377":"08ef76ff","815":"c728e7f6","841":"31f1fc9a","856":"4f6e0c73"}[chunkId] + ".chunk.js";
};